// app/src/entities/user/ui/UserCard/constants/cardConstants.js
import React from 'react';

export const RATING_LEVELS = {
  legend: { min: 1000, icon: '🏆', color: '#ffaa44', label: 'Легенда', level: 4 },
  master: { min: 500, icon: '⭐', color: '#c0c0c0', label: 'Мастер', level: 3 },
  veteran: { min: 100, icon: '🌟', color: '#cd7f32', label: 'Ветеран', level: 2 },
  novice: { min: 0, icon: '✨', color: '#6c757d', label: 'Новичок', level: 1 }
};

const LibrarianIcon = () => React.createElement('svg', {
  width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5"
}, [
  React.createElement('rect', { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "r1" }),
  React.createElement('path', { d: "M8 4V20M12 8h4M12 12h4M18 6l2-2v16l-2-2", key: "p1" })
]);

const DonorIcon = () => React.createElement('svg', {
  width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5"
}, [
  React.createElement('path', { d: "M3 7h16c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h11", key: "p1" }),
  React.createElement('circle', { cx: "17", cy: "14", r: "2", key: "c1" }),
  React.createElement('circle', { cx: "13", cy: "14", r: "1.5", key: "c2" })
]);

const SuperuserIcon = () => React.createElement('svg', {
  width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5"
}, [
  React.createElement('path', { d: "M5 18l1-11 4 4 2-6 2 6 4-4 1 11H5z", key: "p1" }),
  React.createElement('circle', { cx: "12", cy: "12", r: "3", key: "c1" })
]);

const ModeratorIcon = () => React.createElement('svg', {
  width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5"
}, [
  React.createElement('path', { d: "M12 2L4 5v7c0 4 3 7 8 9 5-2 8-5 8-9V5l-8-3z", key: "p1" }),
  React.createElement('path', { d: "M9 12l2 2 4-5", key: "p2" })
]);

const LegendIcon = () => React.createElement('svg', {
  width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5"
}, [
  React.createElement('path', { d: "M12 4l1.5 5h4.5l-3.5 3 1.5 5-4-3-4 3 1.5-5-3.5-3h4.5L12 4z", key: "p1" }),
  React.createElement('path', { d: "M5 8c0 0-2 3 0 6M19 8c0 0 2 3 0 6", key: "p2" })
]);

export const ROLE_CONFIG = {
  legend: { type: 'legend', name: 'Легенда', icon: LegendIcon, color: '#ffcc44', description: 'Пользователь первого дня' },
  superuser: { type: 'superuser', name: 'Админ', icon: SuperuserIcon, color: '#ff4444', description: 'Полный доступ' },
  moderator: { type: 'moderator', name: 'Модератор', icon: ModeratorIcon, color: '#44aaff', description: 'Контроль контента' },
  librarian: { type: 'librarian', name: 'Библиотекарь', icon: LibrarianIcon, color: '#44ff88', description: 'Хранитель знаний' },
  donor: { type: 'donor', name: 'Донатер', icon: DonorIcon, color: '#ffaa44', description: 'Поддержал проект' }
};

export const CARD_FRAME_CLASSES = {
  legend: 'card-frame-legend',
  superuser: 'card-frame-superuser',
  moderator: 'card-frame-moderator',
  librarian: 'card-frame-librarian',
  donor: 'card-frame-donor'
};
